import styled from '@emotion/styled';
import {mq} from '@styles/helpers';
import {Devices} from '@styles/tokens';

export const ColorOverlay = styled.div`
  position: absolute;
  top:0;
  left:0;
  bottom:0;
  right:0;
  content:' ';
  z-index: 4;

  svg{
    width:30%;
    position: absolute;
    opacity: 0;

    :nth-of-type(1){
      top:10%;
      right:10%;
    } 

    :nth-of-type(2){
      bottom:24%;
      right:10%;
    } 

    :nth-of-type(3){
      top:10%;
      left:10%;
    } 
  }
`;

export const CardItem = styled.div`
    position: absolute;
    height: 90%;
    aspect-ratio: 1 / 1.35;
    border-radius:6px;
    box-shadow: 0 2px 3px 0 rgba(0,0,0,0.1);
    overflow:hidden;

    ${mq(Devices.mobile)} {
      height: 100%;
      max-width: 98vw;
    }
`;

export const CardImage = styled.div`
    position: relative;
    height:100%;
`;

export const CardInfo = styled.div<{privacyEnabled?:boolean, coloring?:any}>`
  background: ${props => props.coloring? props.coloring.background :"#ffffffbe"};
  position: absolute;
  bottom:0;
  left:0;
  width:100%;
  min-height:120px;
  display:grid;
  grid-template-columns: 2fr 1.2fr;
  padding:20px;
  align-items: center;
  color:${props => props.coloring?props.coloring.color :"#000"};

  div:nth-of-type(2){
    display: ${props => props.privacyEnabled?"none":"unset"};
  }

  ${mq(Devices.tablet)}{
    min-height:90px;
  }
`;

export const CardInfoName = styled.p`
  font-size: 26px;
  line-height: 28px;
  font-weight: 600;

  ${mq(Devices.tablet)}{
    line-height: 20px;
    font-size: 3vw;
  }

  ${mq(Devices.mobile)}{
    font-size: 6vw;
  }
`;

export const CardInfoLastname = styled(CardInfoName)`
  font-weight: 400;
  font-size: 22px;

  ${mq(Devices.tablet)}{
    font-size: 2.5vw;
  }

  ${mq(Devices.mobile)}{
    font-size: 5vw;
  }
`;

export const CardInfoPercentage = styled.div`
  font-size: 20px;
  font-weight: 400;
  
  span{
    display: inline-block;
    font-weight: 600;
    
  }

  ${mq(Devices.tablet)}{
    font-size: 2.3vw;
  }

  ${mq(Devices.mobile)}{
    font-size: 4vw;
  }
`;